import clearSearchIcon from '../../assets/icons/clear-search-icon.svg';

export default function ClearSearchIcon({ className }: { className?: string }) {
  return (
    <img
      src={clearSearchIcon}
      alt="Clear Search"
      className={className}
    />
  );
}
